var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"playButton",staticClass:"controls"},[_c('md-button',{staticClass:"play",attrs:{"id":"controls","type":"button"},nativeOn:{"click":function($event){return _vm.toggleControl($event)}}},[_vm._v("\n    "+_vm._s(_vm.msg)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85226d80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaPlayer/Controls.vue
// module id = null
// module chunks = 